import create from "zustand";

interface IAuthorizationStore {
  userId: string | null;
  tokenSecurity: string | null;
  setAuthorization: (userId: string, tokenSecurity: string) => void;
  deleteAuthorization: () => void;
}

export const useGetAuthorizationStore = create<IAuthorizationStore>((set) => ({
  userId: localStorage.getItem("user-id"),
  tokenSecurity: localStorage.getItem("token-security"),
  setAuthorization: (userId: string, tokenSecurity: string) => {
    set({ userId: userId, tokenSecurity: tokenSecurity });
    localStorage.setItem("token-security", tokenSecurity ? tokenSecurity : "");
    localStorage.setItem("user-id", userId ? userId : "");
  },
  deleteAuthorization: () => {
    set({ userId: null, tokenSecurity: null });
    localStorage.removeItem("token-security");
    localStorage.removeItem("user-id");
  },
}));
